const CONTACT_REQUIRED_FIELDS = [
  "function",
  "type",
  "name",
  "emailAddress",
  "content",
]

export const RequiredFields = {
  CONTACT_REQUIRED_FIELDS,
}
